import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import ProductCardList from "./ProductCardList";
import FilterOptions from "./FilterOptions";

const ContentProducts = () => {
    return (
        <div className="content-products position-relative">
            <div className="top-fixed-menu-wrapper">
                <div id="category-product-filter" className="container xpy-2 xpx-1">
                    <div className="swiper list-products-swiper element d-block d-md-none xpy-2 xpx-2">
                        <div className="swiper-wrapper">
                            <li className="nav-item swiper-slide active">
                                <div className="link">
                                    <IconName name="phone" className="icon"/>
                                    <span>گوشی موبایل</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="laptop" className="icon"/>
                                    <span>تبلت و لپ تاپ</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="watch" className="icon"/>
                                    <span>ساعت هوشمند</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="home" className="icon"/>
                                    <span>خانه هوشمند</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="cable" className="icon"/>
                                    <span>لوازم جانبی</span>

                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                            <li className="nav-item swiper-slide">
                                <div className="link">
                                    <IconName name="controller" className="icon"/>
                                    <span>کنسول بازی</span>
                                </div>
                            </li>
                        </div>
                    </div>
                    <div className="category-product container">
                        <div className="category-lists element">
                            <select className="category-select form-select d-none d-md-block">
                                <option>محبوب ترین ها</option>
                                <option>پربازدید ترین ها</option>
                                <option>ارزان ترین ها</option>
                                <option>گران ترین ها</option>
                            </select>
                            <div className="category-select form-select d-flex d-md-none"
                                 id="select-btn-filter-product-responsive"><span>پربازدیدترین ها</span>
                            </div>
                            <IconName name="expand_more" className="icon position-absolute"/>
                        </div>
                        <div className="swiper list-products-swiper element d-none d-md-block">
                            <div className="link-products-list-prev d-none d-lg-block"><IconName name="chevron_left"
                                                                                                 className="icon xmr-2"/>
                            </div>
                            <div className="swiper-wrapper">
                                <li className="nav-item swiper-slide active">
                                    <div className="link">
                                        <IconName name="phone" className="icon"/>
                                        <span>گوشی موبایل</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="laptop" className="icon"/>
                                        <span>تبلت و لپ تاپ</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="watch" className="icon"/>
                                        <span>ساعت هوشمند</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="home" className="icon"/>
                                        <span>خانه هوشمند</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="cable" className="icon"/>
                                        <span>لوازم جانبی</span>

                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide">
                                    <div className="link">
                                        <IconName name="controller" className="icon"/>
                                        <span>کنسول بازی</span>
                                    </div>
                                </li>
                            </div>
                            <div className="link-products-list-next d-none d-lg-block"><IconName name="chevron_left"
                                                                                                 className="icon xmr-2"/>
                            </div>

                        </div>
                        <div className="d-none d-md-block">
                            <div id="filter-toggle-button"
                                 className="filter-button category-select element">

                                <IconName name="filter_alt" className="icon filter-icon"/>
                                <span className="number-filter-icon change-number-filter">0</span>
                                <span>فیلتر کردن</span>
                                <span id="icon-more-filter"><IconName name="expand_more"
                                                                      className="icon more-icon d-none d-lg-block"/></span>

                            </div>
                        </div>
                        <div className="d-block d-md-none filter-box-responsive">
                            <div id="button-toggle-filter-responsive" className="filter-button category-select element">
                                <span>فیلتر کردن</span>
                                <IconName name="filter_alt" className="icon filter-icon"/>
                                <span className="number-filter-icon">0</span>
                            </div>
                        </div>

                        <div className="list-card-product element">
                            <span id="card-list-products" className="xmr-2 xmr-lg-4 xp-3"><IconName name="list_alt"
                                                                                                    className="icon icon-grid"/><IconName
                                name="grid_alt" className="icon icon-list"/></span>
                        </div>
                    </div>
                    <div className="filter-options">
                        <FilterOptions/>
                    </div>

                    <div className="d-block d-md-none">
                        <div id="toggle-select-filter-responsive"
                             className="category-select-responsive position-absolute">
                            <ul className="list-unstyled">
                                <li className="active position-relative">
                                    <a href="#">
                                        <span>پربازدیدترین ها</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                                <li className=" position-relative">
                                    <a href="#">
                                        <span>پرفروش‌ترین</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                                <li className=" position-relative">
                                    <a href="#">
                                        <span>محبوب‌ترین</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                                <li className=" position-relative">
                                    <a href="#">
                                        <span>جدیدترین</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                                <li className=" position-relative">
                                    <a href="#">
                                        <span>ارزان‌ترین</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                                <li className=" position-relative">
                                    <a href="#">
                                        <span>گران‌ترین</span>
                                        <IconName name="check" className="icon position-absolute"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <ProductCardList/>
            </div>
        </div>
    );
};

export default ContentProducts;
